import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth doit être utilisé dans un AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage('user', null);
  const [isLoading, setIsLoading] = useState(true);

  // Simuler un délai de chargement initial
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const login = async (email, password) => {
    try {
      setIsLoading(true);
      
      // Simulation d'une API d'authentification
      // Dans une vraie application, vous feriez un appel API ici
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Validation simple pour la démo
      if (email === 'admin@smsgateway.com' && password === 'admin123') {
        const userData = {
          id: 1,
          email: email,
          nom: 'Admin',
          prenom: 'Système',
          role: 'admin',
          date_creation: '2024-01-01',
          date_derniere_connexion: new Date().toISOString()
        };
        
        setUser(userData);
        return { success: true, user: userData };
      } else if (email === 'user@example.com' && password === 'user123') {
        const userData = {
          id: 2,
          email: email,
          nom: 'Utilisateur',
          prenom: 'Test',
          role: 'user',
          date_creation: '2024-01-15',
          date_derniere_connexion: new Date().toISOString()
        };
        
        setUser(userData);
        return { success: true, user: userData };
      } else {
        return { 
          success: false, 
          error: 'Email ou mot de passe incorrect' 
        };
      }
    } catch (error) {
      return { 
        success: false, 
        error: 'Erreur de connexion. Veuillez réessayer.' 
      };
    } finally {
      setIsLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
  };

  const updateUser = (userData) => {
    setUser(prev => ({ ...prev, ...userData }));
  };

  const isAuthenticated = !!user;
  const isAdmin = user?.role === 'admin';

  const value = {
    user,
    isAuthenticated,
    isLoading,
    isAdmin,
    login,
    logout,
    updateUser
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
